import React, {Component, useCallback, useEffect} from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import PageMeta from 'components/PageMeta';
import Video from 'components/Video';
import CheckoutButton from 'components/CheckoutButton';
import Footer from 'components/Elements/Footer';
import logoTrees from 'static/logo/logo-trees-for-future-white.png';
import uhcLogo from 'static/logo/frn-uhc-logo.svg';
import uhcProductImage from 'static/uhc21-product.jpg';
import SpeakersGroupByCollection from 'components/Uhc/UhcSpeaker';
import {SalesDisclaimer, UhcUpsell} from 'components/SalesCta';
import Section, {SectionImage} from 'components/Elements/Section';
import useBeacon from 'utils/useBeacon';
import IconList, {IconListItem} from 'components/Elements/IconList';
import {TestimonialCircle} from 'components/Testimonial';
import {faCartPlus} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export default function () {
  useBeacon();
  return (
    <div className="page page-nosocial">
      <PageMeta title="UHC Upsell" description="UHC upsell page" />

      <div className="page-content">
        <Section
          id="section-uhc-header"
          className="section-angle-first"
          innerClass="text-white text-center"
          color="black"
        >
          <Container>
            <Row className="mb-4">
              <Col>
                <h3 className="section-heading mb-2">
                  Thank you for joining <em>Healthy Heart!</em>
                </h3>
                <h5 className="text-400 m-0">
                  <em>
                    One quick thing before you go. <br className="d-none d-sm-block d-lg-none" />
                    You’ll never see this opportunity again.
                  </em>
                </h5>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col lg="10" className="video-col px-0 px-sm-3">
                <Video url="https://www.youtube.com/watch?v=QEuhg6Wz_cQ" label="HHC - UHC Upsell" />
              </Col>
            </Row>
          </Container>
        </Section>

        <SectionImage
          id="section-uhc-lifespan-1"
          imgPosition="right"
          imgUrl={require('static/backgrounds/1190433344.jpg')}
          color="white"
        >
          <h2 className="section-heading">What do people with the longest lifespan have in common?</h2>
          <h5 className="mt-0">Five places in the world have the highest concentration of 100 year olds.</h5>
          <p>
            These longevity hotspots are where you’ll find the world’s <strong>healthiest</strong> communities.
          </p>
          <p>No, they didn’t discover the fountain of youth.</p>
          <p>
            But people who live there have a few <strong>KEY</strong> things in common. These are scientifically
            studied, proven, and <em>repeatable</em> by you.
          </p>
        </SectionImage>

        <SectionImage
          id="section-uhc-lifespan-2"
          imgPosition="left"
          imgUrl={require('static/backgrounds/1241736799.jpg')}
          color="light-gray"
        >
          <h2 className="section-heading">
            The people with the <em>longest lifespans</em> know how to live and what to eat to:
          </h2>
          <IconList>
            <IconListItem>
              Live an exceptionally healthy life without the common diseases that afflict masses of people in other
              areas of the world
            </IconListItem>
            <IconListItem>
              Avoid the stress of crushing medical debt, insurance headaches, and a calendar full of nonstop doctor’s
              appointments
            </IconListItem>
            <IconListItem>
              Say goodbye to sickness and hello to health — without a cabinet full of prescriptions or even an armload
              of expensive supplements
            </IconListItem>
            <IconListItem>Stay at their ideal weight for life, without even thinking about it</IconListItem>
            <IconListItem>
              Enjoy energy all day — without depending on caffeine, sugar, or other stimulants. And fall asleep easily
              at night.
            </IconListItem>
          </IconList>
        </SectionImage>

        <Section id="section-uhc-info" className="section-uhc-info" innerClass="text-center" color="white">
          <Container>
            <Row>
              <Col>
                <h2 className="section-heading mb-3">
                  A Special, One-Time Offer <br className="d-none d-xl-block" />
                  For Healthy Heart Participants
                </h2>
                <p>
                  <em>This opportunity won’t be available again at this price after you close this page.</em>
                </p>
                <h4 className="mb-3">
                  For over a decade, Food Revolution Network has worked <br className="d-none d-xl-block" />
                  with the world’s foremost experts in healthy living.
                </h4>
                <h4 className="mt-0 mb-3">
                  We’ve compiled 20 of our best health-centric interviews <br className="d-none d-xl-block" />
                  in the Ultimate Health Collection.
                </h4>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md="10" lg="8" xl="6">
                <img src={uhcLogo} />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col>
                <h4 className="text-400 mt-3">Add the Ultimate Health Collection to your cart now for $47</h4>
                <p>Get the best health of your life.</p>
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="section-uhc-offer-1" color="gradient-indigo-purple-right">
          <Container>
            <Row>
              <Col>
                <UhcUpsell />
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="section-uhc-testimonials" color="white">
          <Container>
            <Row>
              <Col>
                <h2 className="section-heading text-center mb-5">
                  What People Are Saying About <br className="d-none d-xl-block" />
                  Food Revolution Network Interviews
                </h2>
                <TestimonialCircle id="uhc-rajiv-b" />
                <hr className="my-5" />
                <TestimonialCircle id="uhc-ginny-o" imgPosition="right" />
                <hr className="my-5" />
                <TestimonialCircle id="uhc-ann-s" />
                <p className="text-center text-16 mt-5 mb-0">
                  <em>These testimonials reflect people’s unique experience. Your specific experience will vary.</em>
                </p>
              </Col>
            </Row>
          </Container>
        </Section>

        <SectionImage
          id="section-uhc-imagine-1"
          imgPosition="right"
          imgUrl={require('static/backgrounds/920522262.jpg')}
          color="light-gray"
        >
          <Container>
            <Row>
              <Col>
                <h5 className="section-heading">Imagine being able to:</h5>
                <IconList>
                  <IconListItem>Live longer</IconListItem>
                  <IconListItem>Live better</IconListItem>
                  <IconListItem>Beat cancer</IconListItem>
                  <IconListItem>Achieve peak performance</IconListItem>
                  <IconListItem>Prevent Alzheimer’s</IconListItem>
                  <IconListItem>Master the psychology of eating</IconListItem>
                  <IconListItem>Use food to improve your immunity</IconListItem>
                  <IconListItem>Shed excess pounds</IconListItem>
                </IconList>
              </Col>
            </Row>
          </Container>
        </SectionImage>

        <SectionImage
          id="section-uhc-imagine-2"
          imgPosition="left"
          imgUrl={require('static/backgrounds/1288965935.jpg')}
          color="light-gray"
        >
          <Container>
            <Row>
              <Col>
                <IconList className="mt-0">
                  <IconListItem>Shed excess pounds</IconListItem>
                  <IconListItem>Feel better</IconListItem>
                  <IconListItem>Sleep deeply</IconListItem>
                  <IconListItem>Nourish yourself</IconListItem>
                  <IconListItem>End inflammation</IconListItem>
                  <IconListItem>Quit sugar</IconListItem>
                  <IconListItem>Love your body exactly as it is</IconListItem>
                  <IconListItem>Enjoy incredible digestion</IconListItem>
                  <IconListItem>Share what you learn with your loved ones</IconListItem>
                </IconList>
              </Col>
            </Row>
          </Container>
        </SectionImage>

        <Section id="section-uhc-speakers" color="white">
          <Container>
            <Row>
              <SpeakersGroupByCollection />
            </Row>
          </Container>
        </Section>

        <Section id="section-uhc-about" color="gradient-indigo-purple-right" innerClass="text-center text-white">
          <Container>
            <Row className="justify-content-center">
              <Col>
                <h2 className="section-heading">About the Ultimate Health Collection</h2>
                <p>
                  Since 2012, John Robbins — bestselling author of <em>Diet for a New America</em>{' '}
                  <br className="d-none d-xl-block" />
                  and Food Revolution Network co-founder — has interviewed hundreds of the world’s{' '}
                  <br className="d-none d-xl-block" />
                  leading food experts in our annual Food Revolution Summits.
                </p>
                <p>
                  We compiled 20 of the most impactful interviews ever conducted <br className="d-none d-xl-block" />
                  and put them into this Ultimate Health Collection.
                </p>
                <p>
                  The only other way to buy this beloved collection would be to purchase all of our past{' '}
                  <br className="d-none d-xl-block" />
                  Food Revolution Summits and to spend more than $1,500 in the process. You can get the{' '}
                  <br className="d-none d-xl-block" />
                  Ultimate Health Collection for a mere fraction of that cost — just $47!
                </p>
                <CheckoutButton className="offer-box-button offer-box-button-upsell">
                  <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Yes, Add to Order
                </CheckoutButton>
                <SalesDisclaimer iconColor="white" />
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="section-uhc-testimonials-2" color="white">
          <Container>
            <Row>
              <Col>
                <TestimonialCircle id="uhc-myra-a" />
                <hr className="my-5" />
                <TestimonialCircle id="uhc-molly-s" imgPosition="right" />
              </Col>
            </Row>
          </Container>
        </Section>

        <Section
          id="section-uhc-offer-2"
          color="gradient-indigo-purple-right"
          className="section-angle-last"
          angle="none"
        >
          <Container>
            <Row>
              <Col>
                <UhcUpsell />
              </Col>
            </Row>
          </Container>
        </Section>
      </div>

      <Footer />
    </div>
  );
}
